import {Injectable} from '@angular/core';
import {Headers, Http, Request, RequestOptions, RequestOptionsArgs, Response, XHRBackend} from '@angular/http';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class HttpServiceProvider extends Http {
  constructor(backend: XHRBackend, options: RequestOptions) {
    let token = sessionStorage.getItem("auth_token");
    options.headers.set("Authorization", "Bearer " + token);
    super(backend, options);
  }

  setToken(token: string) {
    sessionStorage.setItem("auth_token", token);
  }

  getToken(): string {
    return sessionStorage.getItem("auth_token");
  }

  clearToken() {
    sessionStorage.removeItem("auth_token");
  }

  request(
    url: string | Request,
    options?: RequestOptionsArgs
  ): Observable<Response> {
    let token = sessionStorage.getItem("auth_token");
    if (typeof url === "string") {
      if (!options) {
        options = {headers: new Headers()};
      }
      options.headers.set("Authorization", "Bearer " + token);
    } else {
      url.headers.set("Authorization", "Bearer " + token);
    }
    return super.request(url, options).catch(this.catchAuthError(this));
  }

  private catchAuthError(self: HttpServiceProvider) {
    return (res: Response) => {
      if (res.status === 401 || res.status === 403) {
        self.clearToken();
      }
      return Observable.throw(res);
    };
  }
}



// WEBPACK FOOTER //
// ./src/providers/http-service/http-service.ts